<template lang="pug">
    section
        div.tab-content.tab-content-center
            //- No transfers
            p.no-item(v-if="!audienceHasTransfers") No transfer associated to this audience.
            //- Add transfers
            button.btn.btn--medium.btn--round.btn-rev.mg-bt-32(
                 v-if="monitoringActionAllowed && selectedAudienceTransfers.length === 0"
                @click="callTransferForm()") Add transfer(s)

        div.tab-content.scrollbar.is-scrollable
            //- Transferts list
            template(v-if="audienceHasTransfers")
                div.item-transfer(v-for="transfer of selectedAudienceTransfers" :key="transfer.id")

                    section.detail-section
                        div.item-info
                            div.item-id {{ transfer.id }}
                            div.item-value
                                div.item-status(:title="transfer.status" :class="itemCssClasses(transfer.status)")
                                input.item-label.transfer-label(
                                    type="text"
                                    :id="'label of transfer ' + transfer.id"
                                    :class="inputClass"
                                    :name="'label of transfer ' + transfer.id"
                                    placeholder="Choose a nice name for your transfer"
                                    v-model="transferFormLabel[transfer.id]"
                                    :title="transferFormLabel[transfer.id]"
                                    v-validate="'min:3|max:200|required'"
                                    @blur="handleResetFieldOnLeave('label', transfer.id)"
                                    @keyup.enter="editTransferInfo(transfer.id, null, 'label', null, $event)")
                                span.form-validate-error {{ errors.first('label of transfer ' + transfer.id) }}


                        div.sub-header.l-flex-row--between
                            div.sub-header-title Details
                        div.info-content
                            //- START DATE - END DATE
                            div.info-block
                                div.label Date
                                div.info-block-date.l-flex-row.l-align-center
                                    div.date-start {{ transfer.createdAt }}
                                    svg-icon.date-separator(name='arrow-direction_right' size="small")
                                    div.date-end(v-if="!monitoringActionAllowed") {{ transfer.endDate }}
                                    div.item-value(v-else)
                                        el-date-picker.date-end(
                                            v-model="transferFormEndDate[transfer.id]"
                                            :name="'transfer-end_date' + transfer.id"
                                            :id="'transfer-end_date' + transfer.id"
                                            editable=true
                                            clearable=false
                                            type="date"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Transfer end date"
                                            :picker-options="endDateOptions"
                                            v-validate="'date_format:yyyy-MM-dd|required'"
                                            @blur="handleResetFieldOnLeave('endDate', transfer.id)"
                                            @change="editTransferInfo(transfer.id, null,'endDate', null)")
                                    span.form-validate-error {{ errors.first('transfer-end_date ' + transfer.id) }}

                            //- email
                            div.info-block
                                div.label Email
                                div.item-value
                                    input.email-input(
                                        :class="inputClass"
                                        :id="'transfer-email' + transfer.id"
                                        :name="'transfer-email ' + transfer.id"
                                        type="text"
                                        :placeholder="transferFormEmail[transfer.id]"
                                        v-model="transferFormEmail[transfer.id]"
                                        :title="transferFormEmail[transfer.id]"
                                        v-validate="'min:1|max:255|required|email'"
                                        @blur="handleResetFieldOnLeave('email', transfer.id)"
                                        style="text-overflow: ellipsis;width: 100%;padding-left:0"
                                        @keyup.enter="editTransferInfo(transfer.id, null,'email', null, $event)")
                                    span.form-validate-error(v-if="errors.first('transfer-email ' + transfer.id)") The transfer email field must be a valid email'

                            //- CC Mail
                            div.info-block
                                div.label
                                    span Cc
                                    span.list-counter(v-if="monitoringActionAllowed") {{ transferCcToArray(transfer.cc).length }} /10
                                div.cursor.item-value(
                                    v-if="transferCcToArray(transfer.cc).length >= 1"
                                    :class="{'cursor': monitoringActionAllowed}"
                                    @click="displayEdit('cc', transfer)")
                                    div.value.value-list.cc-email
                                            span.value-item(
                                            :title="cc"
                                            v-for="(cc, idx) of transferCcToArray(transfer.cc)" :key="idx"
                                            :class="{'no-edit': !monitoringActionAllowed}") {{ cc }}
                                    svg-icon.cursor.edit-action(v-if="monitoringActionAllowed" name='edit' size="small")
                                button.btn--xsmall.btn-add(
                                    v-if="!displayEditSingleInput.cc[transfer.id] && transferCcToArray(transfer.cc).length === 0 && monitoringActionAllowed"
                                    @click="displayEdit('cc', transfer)") + add

                            //- Modal single edit
                            transition(name="slide-fade")
                                div.edit-single-wrapper(v-if="displayEditSingleInput.cc[transfer.id]")
                                    EmailCcField(
                                        parent="Monitoring"
                                        placeholder="Add, edit an email cc"
                                        @formCcListUpdate="updateFormCcList"
                                        monitoringType="transfer"
                                        :defaultValues="defaultCcValues"
                                        :maxItems="10"
                                    )
                                    footer.l-flex-row--rev
                                        button.btn-cancel.btn--small.btn--round(@click="closeEmailCcWrapper") cancel
                                        button.btn.btn-pale.btn--small.btn--round(
                                            @click="editTransferInfo(transfer.id, null,'cc', null)"
                                            :class="{'ui-disabled': disableCcSave}"
                                            ) edit

                            template(v-if="transferType(transfer) === 'Partner'")
                                div.info-block
                                    div.label Delivering type
                                    div.value {{ transfer.delivering_type }}
                                div.info-block
                                    div.label Cookie split
                                    div.value {{ formatCookieSplit(transfer.cookie_split) }}
                                div.info-block(v-if="transfer.reference_id")
                                    div.label Reference ID
                                    div.value(:title="transfer.reference_id") {{ transfer.reference_id }}
                                div.info-block
                                    div.label CPM
                                    div.value {{ transfer.cpm ? transfer.cpm : '-' }}
                                div.info-block
                                    div.label Media rate
                                    div.value {{ transfer.media_rate ? transfer.media_rate : '-' }}
                                div.info-block(v-if="displayPushOfStock")
                                    div.label Push of stock
                                    div.value(v-if="(isWeboAdmin || isWeboEmployee || (monitoringActionAllowed && !audienceInfo.isThirdParty)) && !isPushOfStockQuotaExceeded && transfer.bootstrap_status === 'not_applicable' && !isTransferExpired(transfer)")
                                        button.btn-pushofstock.btn-pale.btn--small.btn--round(@click="pushOfStock(transfer)") Push
                                    div.value.exceeded(v-else-if="isPushOfStockQuotaExceeded && transfer.bootstrap_status === 'not_applicable' && !isTransferExpired(transfer)")
                                        span.form-validate-error(:title="dailyQuotaReachedMessage") {{dailyQuotaReachedMessage}}
                                    div.value(v-else-if="isTransferExpired(transfer)") {{ transfer.bootstrap_status }}
                                    div.value(v-else) {{ transfer.bootstrap_status }}

                    section.detail-section
                        div.sub-header.l-flex-row--between
                            div.sub-header-title {{ transferType(transfer) }}
                        div.info-content
                            template(v-if="transferType(transfer) === 'Partner'")
                                div.info-block
                                    div.label Partner Name
                                    div.value {{ getTransferAccountDsps(transfer, 'partnerLabel') }}
                                div.info-block
                                    div.label Partner account label
                                    div.value {{ getTransferAccountDsps(transfer, 'label', 'N/A') }}
                                div.info-block
                                    div.label Partner account id
                                    div.value {{ getTransferAccountDsps(transfer, 'dsp_client_id') }}
                                div.info-block
                                    div.label Partner segment id
                                    div.value {{ formatDSPSegmentId(transfer.dsp_segment_id) }}

                            template(v-else)
                                div.info-content
                                    div.info-block
                                        div.label Pixel url
                                        div.value.css-cut-long-text(:title="removeRandomParam(transfer.pixel_url)") {{ removeRandomParam(transfer.pixel_url) }}
                                    switchItem.info-block.switch-random.l-flex-box.l-align-center(:class="{'ui-disabled': !monitoringActionAllowed}"
                                        label="Random" inputName="pixelUrlRandom" :isSwitchActive="setSwitchActive(transfer)"
                                        :type="transfer.pixel_url" :loadData="editTransferInfo" :key="transfer.id"
                                        :noFlexBetween="true" :ref="'switch-transfer-'+transfer.id")

                    //- Delete transfer
                    footer.footer-transfer
                        button.btn.btn--medium.btn--round.btn-rev.btn-delete(
                            v-if="monitoringActionAllowed"
                            @click="deleteTransferHandler(transfer.id, transfer.audience_id)") Delete transfer
</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { isEmpty, isEqual, pick, get, isNil, join, includes, toNumber, find } from 'lodash'
import { PIXEL_URL_RANDOM_PARAM } from '@/utils/constants'
import EmailCcField from '@/components/common/EmailCcField'
import SwitchItem from '@/components/common/SwitchItem'

export default {
    name: 'MonitoringTransfers',
    created() {
        if (this.audienceInfo) this.updateTransferData()
    },
    components: {
        EmailCcField,
        SwitchItem
    },
    data() {
        return {
            displayEditSingleInput: {
                label: false,
                endDate: false,
                email: false,
                cc: false,
                tags: false,
                bootstrap: false
            },
            transferFormLabel: {},
            transferFormCc: [],
            transferFormEmail: {},
            transferFormEndDate: {},
            audienceFormCc: [],
            defaultCcValues: [],
            isAudienceEditing: false
        }
    },
    props: {
        audienceInfo: { type: Object, required: true }
    },
    watch: {
        selectedAudienceId: {
            handler: function(newValue, oldValue) {
                if (!isNil(newValue) && !isEqual(newValue, oldValue)) {
                    this.setSelectedAudienceHaveDeletedCriteria({ result: false })
                    //to check if bootstrap start and push of stock buttons must be disabled or not
                    this.retrieveAttributionCounterTransfer()
                }
            }
        },
        selectedAudienceTransfersIds: {
            handler: function(newValue, oldValue) {
                if (!isEqual(newValue, oldValue)) {
                    this.updateTransferData()
                }
            }
        },
        audienceInfo: {
            handler: function(newValue) {
                if (!isNil(newValue)) {
                    this.audienceFormStatus = newValue.status
                    this.audienceFormLabel = newValue.label
                    this.audienceFormEndDate = dayjs(newValue.endDate).format('YYYY-MM-DD')
                    this.audienceFormEmail = newValue.email
                    this.audienceFormCc = isEmpty(newValue.cc) ? [] : newValue.cc.split(',')
                    this.audienceTagsList = isNil(newValue.tags) || isEmpty(newValue.tags) ? [] : newValue.tags
                }
            },
            deep: true
        },
        activeTab: {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue === 'information') {
                        //to check if bootstrap start and push of stock buttons must be disabled or not
                        this.retrieveAttributionCounterTransfer()
                    }
                }
            }
        },
        $route: {
            handler: function(newValue) {
                if (newValue.path !== '/' + this.accountId + '/monitoring') {
                    for (const transfer of this.selectedAudienceTransfersIds) {
                        this.handleResetFieldOnLeave('label', transfer)
                        this.handleResetFieldOnLeave('email', transfer)
                    }
                }
            },
            deep: true
        }
    },

    computed: {
        ...mapState('ui/monitoring', {
            activeTab: state => state.activeTab,
            selectedAudienceId: state => state.selectedRowId
        }),
        ...mapState('data/accountsDsps', {
            accountsDsps: state => state.list
        }),
        ...mapState('data/transfer', {
            transferList: state => state.list
        }),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),
        ...mapState('ui/settings', {
            bootstrapPush: state => state.general.bootstrapPush
        }),
        ...mapState('account', {
            accountId: state => state.accountId,
            attributionCounterTransfer: state => state.attributionCounterTransfer,
            userRole: state => state.userRole,
            dailyPushOfStockLimit: state => state.dailyPushOfStockLimit
        }),

        selectedAudienceTransfersIds() {
            return this.selectedAudienceTransfers.map(transfer => transfer.id)
        },

        inputClass() {
            return this.monitoringActionAllowed ? 'edit-single-input' : ' ui-disabled no-edit'
        },

        audienceHasTransfers() {
            return !isEmpty(this.selectedAudienceTransfers)
        },

        selectedAudienceTransfers() {
            const selectedAudienceTransferList = pick(this.transferList, this.selectedAudienceId)
            const result = !isEmpty(selectedAudienceTransferList) ? [...selectedAudienceTransferList[this.selectedAudienceId]] : []
            return result
        },

        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },

        isWeboAdmin() {
            return this.userRole === 'webo_admin'
        },
        isWeboEmployee() {
            return this.userRole === 'webo_employee'
        },

        displayPushOfStock() {
            const { type } = this.audienceInfo
            if (this.isWeboAdmin) return true
            if  (this.isWeboEmployee && this.bootstrapPush) return true
            if (type === 'cclones' && this.bootstrapPush) return true
            if (this.bootstrapPush && this.monitoringActionAllowed) return true
            return false

        },

        // CC
        disableCcSave() {
            if (this.defaultCcValues) return isEqual(this.defaultCcValues, this.transferFormCc)
            return this.transferFormCc === 0
        },

        isPushOfStockQuotaExceeded() {
            //checking if adding this current Volume would exceed daily push of stock limit
            if (this.userRole !== 'webo_admin') return this.audienceInfo.volume + this.attributionCounterTransfer >= this.dailyPushOfStockLimit
            //webo admin are not affected by quotas
            return false
        },

        endDateOptions() {
            return {
                firstDayOfWeek: 1,
                disabledDate(time) {
                    return (
                        dayjs()
                            .startOf('day')
                            .valueOf() >
                            dayjs(time)
                                .startOf('day')
                                .valueOf() ||
                        dayjs(time).valueOf() >=
                            dayjs()
                                .add(395, 'day')
                                .startOf('day')
                                .valueOf()
                    )
                }
            }
        },

        dailyQuotaReachedMessage() {
            return 'The account daily quota has been reached or would be exceeded. Bootstrap will be available when the quota is reset.'
        }
    },

    methods: {
        ...mapMutations('ui/transfers', ['setShowFormTransfer', 'setShowFormCreateTransfer']),
        ...mapActions('account', ['retrieveAttributionCounterTransfer']),
        ...mapActions('data/transfer', ['editTransfer', 'deleteTransfer']),
        ...mapActions('dashboardAccount', ['retrieveExpiringAudiences', 'retrieveExpiringTransfers']),
        ...mapMutations('ui/monitoring', ['setDisplayModal', 'setDeletedTransfer', 'setSelectedAudienceHaveDeletedCriteria']),

        callTransferForm() {
            this.setShowFormTransfer({ show: true })
            this.setShowFormCreateTransfer({ show: true })
        },
        transferType(transfer) {
            return transfer.pixel_url !== '' ? 'Pixel' : 'Partner'
        },
        itemCssClasses(element) {
            let cssClasses = ''
            if (element === 'inactive') cssClasses += ' is-inactive'
            if (element === 'active') cssClasses += ' is-active'

            return cssClasses
        },
        editTransferInfo(transferId, transferURL, dataToEdit, newValue, event) {
            this.isAudienceEditing = true
            const { transferFormLabel, transferFormEndDate, transferFormEmail, transferFormCc, selectedAudienceId, editTransfer } = this
            const { displayEditSingleInput } = this
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    let _params
                    if (dataToEdit === 'endDate') {
                        if (isNil(transferFormEndDate[transferId])) {
                            this.isAudienceEditing = false
                            return
                        }
                        _params = { params: { end_date: transferFormEndDate[transferId] }, notificationMessage: 'The date has been modified' }
                    } else if (dataToEdit === 'cc')
                        _params = { params: { cc: join(transferFormCc, ',') }, notificationMessage: 'The email_cc has been modified' }
                    else if (dataToEdit === 'label') {
                        _params = { params: { label: transferFormLabel[transferId] }, notificationMessage: 'The label has been modified' }
                    }else if (dataToEdit === 'email')
                        _params = { params: { email: transferFormEmail[transferId] }, notificationMessage: 'The email has been modified' }
                    else if (dataToEdit === 'pixelUrlRandom') {
                        if (!newValue) {
                            //remove random param from pixel_url
                            _params = {
                                params: { pixel_url: this.removeRandomParam(transferURL) },
                                notificationMessage: 'The random parameter has been disabled'
                            }
                        } else {
                            //add random param from pixel_url
                            _params = {
                                params: { pixel_url: this.addRandomParam(transferURL) },
                                notificationMessage: 'The random parameter has been enabled'
                            }
                        }
                    }

                    editTransfer({
                        ..._params,
                        audienceId: selectedAudienceId,
                        id: transferId
                    }).then(() => {
                        this.isAudienceEditing = false
                        if (dataToEdit === 'email' || dataToEdit === 'label') {
                            event.target.blur()
                        }
                        if (dataToEdit === 'label') transferFormLabel[transferId] = _params?.params?.label
                        if (dataToEdit === 'email') transferFormEmail[transferId] = _params?.params?.email
                        if (dataToEdit === 'cc') this.defaultCcValues = this.transferFormCc
                        this.retrieveExpiringAudiences()
                        this.retrieveExpiringTransfers()

                    }).catch((error) => {
                        if(error.apiError.message === 'DataTransfer already exists with same criterias'){
                            // reset value switch item
                            this.$refs[`switch-transfer-${transferId}`][0].isActive = !this.$refs[`switch-transfer-${transferId}`][0].isActive
                        }
                    })

                    // close edit modal
                    if (dataToEdit !== 'pixelUrlRandom') displayEditSingleInput[dataToEdit] = false
                }
            })
        },
        removeRandomParam(pixelURL) {
            const _pixelUrl = pixelURL.toLowerCase()
            const url = includes(_pixelUrl, '&' + PIXEL_URL_RANDOM_PARAM.toLowerCase())
                ? _pixelUrl.split('&' + PIXEL_URL_RANDOM_PARAM.toLowerCase())
                : _pixelUrl.split('?' + PIXEL_URL_RANDOM_PARAM.toLowerCase())
            return join(url, '')
        },
        addRandomParam(pixelURL) {
            // check if URL has params
            const _params = new URL(pixelURL).searchParams
            const params = []
            for (var value of _params.values()) {
                params.push(value)
            }
            if (isEmpty(params)) {
                //no params => add random as first param
                return pixelURL + '?' + PIXEL_URL_RANDOM_PARAM
            } else {
                //params => random as last param
                return pixelURL + '&' + PIXEL_URL_RANDOM_PARAM
            }
        },
        deleteTransferHandler(transferId, audienceId) {
            this.setDeletedTransfer({ transferId, audienceId })
            this.setDisplayModal({ item: 'transfer', display: true })
        },
        isTransferExpired(transfer) {
            return dayjs().isAfter(dayjs(transfer.endDate), 'day')
        },
        // CC
        transferCcToArray(cc) {
            return isEmpty(cc) ? [] : cc.split(',')
        },
        updateFormCcList(ccList) {
            this.transferFormCc = ccList
        },
        setSwitchActive(transfer) {
            return includes(transfer['pixel_url'].toLowerCase(), PIXEL_URL_RANDOM_PARAM.toLowerCase())
        },
        // Modal single edit
        displayEdit(field, transfer) {
            if (this.monitoringActionAllowed) {
                if (transfer) {
                    // edit transfer
                    if (field === 'label') this.transferFormLabel = { ...this.transferFormLabel, [transfer.id]: transfer.label }
                    else if (field === 'endDate') this.transferFormEndDate = { ...this.transferFormEndDate, [transfer.id]: transfer.end_date }
                    else if (field === 'email') this.transferFormEmail[transfer.id] = transfer.email
                    else if (field === 'cc') {
                        this.transferFormCc = isEmpty(transfer.cc) ? [] : transfer.cc.split(',')
                        this.defaultCcValues = isEmpty(transfer.cc) ? [] : transfer.cc.split(',')
                    }

                    if (!isNil(get(this.displayEditSingleInput[field], 'id', null))) {
                        this.displayEditSingleInput[field][transfer.id] = true
                    } else {
                        this.displayEditSingleInput[field] = { [transfer.id]: true }
                    }
                } else {
                    this.displayEditSingleInput[field] = true //edit audience
                }
            }
        },
        closeEmailCcWrapper() {
            this.displayEditSingleInput.cc = false
            this.transferFormCc = this.defaultCcValues
        },
        formatDSPSegmentId(dsp_segment_id) {
            return dsp_segment_id !== '' ? dsp_segment_id : '-'
        },
        formatCookieSplit(cookie_split) {
            if (cookie_split === null) return '1 to 100'
            const cookieSplitValues = cookie_split.split('..').map(x => toNumber(x) + 1)
            return cookieSplitValues.shift().toString() + ' to ' + cookieSplitValues.pop().toString()
        },
        pushOfStock(transfer) {
            this.editTransfer({
                params: { bootstrap: 'bootstrap', bootstrap_status: 'pending' },
                notificationMessage: 'Stock will be pushed to ' + transfer.partner,
                audienceId: this.selectedAudienceId,
                id: transfer.id
            })
        },

        updateTransferData() {
            for (const transfer of this.selectedAudienceTransfers) {
                if (!get(this.transferFormEndDate, `${transfer.id}`)) {
                    this.transferFormEndDate = { ...this.transferFormEndDate, [transfer.id]: transfer.end_date }
                }
                if (!get(this.transferFormEmail, `${transfer.id}`)) {
                    this.transferFormEmail = { ...this.transferFormEmail, [transfer.id]: transfer.email }
                }
                if (!get(this.transferFormLabel, `${transfer.id}`)) {
                    this.transferFormLabel = { ...this.transferFormLabel, [transfer.id]: transfer.label }
                }
            }
        },
        handleResetFieldOnLeave(field, transferId) {
            const transfer = find(this.selectedAudienceTransfers, transfer => toNumber(transfer.id) === toNumber(transferId))
            if (this.isAudienceEditing) return

            if (field === 'label') this.transferFormLabel[transferId] = transfer.label
            if (field === 'endDate') this.transferFormEndDate[transferId] = transfer.endDate
            else if (field === 'email') this.transferFormEmail[transferId] = transfer.email

            this.errors.clear()
        },
        getTransferAccountDsps(transfer, key, defaultValue = '-') {
            const dspId = transfer.accounts_dsp_id
            const $dsp = this.accountsDsps.find(dsp => dsp.id === dspId)
            return $dsp?.[key] ?? defaultValue
        }
    }
}
</script>
